var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarcodeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1 16V4h1.5v12zm2.5 0V4H5v12zM6 16V4h1v12zm2.5 0V4H10v12zm2.5 0V4h2v12zm3 0V4h1v12zm3 0V4h2v12z"
})));
export { SvgBarcodeIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMSAxNlY0aDEuNXYxMnptMi41IDBWNEg1djEyek02IDE2VjRoMXYxMnptMi41IDBWNEgxMHYxMnptMi41IDBWNGgydjEyem0zIDBWNGgxdjEyem0zIDBWNGgydjEyeiIvPjwvc3ZnPg==";